import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
// import { Facebook, FacebookLoginResponse, FacebookOriginal } from '@ionic-native/facebook';
import { DashboardPage } from '../dashboard/dashboard';
import { RegisterPage } from '../register/register';
import { RestProvider } from '../../providers/rest/rest';
import { DataProvider } from '../../providers/data/data';
import { ToastController } from 'ionic-angular';


@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  private email: any;
  private password: any;
  public loading;

  constructor(public navCtrl: NavController, public navParams: NavParams,
      private rest: RestProvider,
      private data: DataProvider,
      private toastCtrl: ToastController,
      // private facebook: FacebookOriginal,
      public loadingController: LoadingController) {
  }

  loginWithFB() {
    /*this.facebook.login(['email', 'public_profile']).then((response: FacebookLoginResponse) => {
      this.facebook.api('me?fields=id,name,email,first_name,picture.width(720).height(720).as(picture_large)', []).then(profile => {
        console.log(profile);
      });
    });*/
  }

  async stopLoading() {
    return await this.loading.dismiss();
  }

  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }

  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }

  ionViewDidLoad() {

  }

  ionViewDidEnter(): void {
    document.getElementById('mainmenu').style.visibility = 'hidden';
    document.getElementById('mainHeader').style.display = 'none';
    document.getElementById('backmenu').style.display = 'none';
  }

  login(){
    this.rest.login(this.email, this.password).subscribe(res => {
      if(res == null) {
        this.email = '';
        this.password = '';
        this.showToast1('Нэвтрэх нэр эсвэл нууц үг буруу байна.');
      } else if(res.result) {
        this.data.userId = res.data.user_id;
        this.data.userName = res.data.first_name;
        this.data.jobName = res.data.job_name;
        this.data.email = res.data.email;
        this.data.image = res.data.image;
        this.data.workYearIn = res.data.work_year_in;
        this.data.workYearStart = res.data.work_year_start;
        this.data.slackName = res.data.slack_name;
        this.data.companyId = res.data.companyId;
        this.data.type = res.data.type;
        // if(parseInt(this.data.type) == 2 || parseInt(this.data.type) == 4) {
        //   this.navCtrl.setRoot(AdminDashboardPage);
        // } else {
          this.navCtrl.setRoot(DashboardPage);
        // }
      } else {
        if(res.msg == 'incorrect') {
          this.password = '';
          this.showToast1('Нэвтрэх нэр эсвэл нууц үг буруу байна.');
        } else {
          this.showToast1('Таны бүртгэл баталгаажаагүй байна.');
        }
      }
    });
  }

  register(){
    this.navCtrl.push(RegisterPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts